import React, { useState, useEffect } from 'react';
import request from 'superagent';
import withConfig from '../../../context/withConfig';
import ImageComponent from './Image';
import { MessageWrapper } from './Message';

const LinkMessage = props => {
  const [siteImage, setSiteImage] = useState();
  const { isStart, isEnd, urlValue } = props;
  const url = urlValue && urlValue.match(/^https?:\/\//i) ? urlValue : `http://${urlValue}`;

  const handleUrlClick = () => {
    const selection = window.getSelection();
    if (selection.type === 'Range') {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const checkImageSize = src => {
    const IMAGE_SIZE_THRESHOLD = 100;

    return new Promise(resolve => {
      const img = new Image();
      img.src = src;
      img.onload = image => {
        try {
          const width = image.path[0].width;
          const height = image.path[0].height;
          resolve(width >= IMAGE_SIZE_THRESHOLD || height >= IMAGE_SIZE_THRESHOLD);
        } catch (error) {
          resolve(false);
        }
      };
      img.onerror = () => {
        resolve(false);
      };
    });
  };

  useEffect(() => {
    const getImagePath = async () => {
      const response = await request.post(`${props.config.botBaseUrl}/public/web-preview`, { url });

      if (
        response &&
        response.body &&
        Object.keys(response.body).length > 0 &&
        response.body.images &&
        response.body.images.length > 0 &&
        response.body.images[0].startsWith('http') &&
        !response.body.images[0].endsWith('.svg')
      ) {
        const isDisplayable = await checkImageSize(response.body.images[0]);
        if (isDisplayable) {
          setSiteImage(response.body.images[0]);
        }
      }
    };
    getImagePath();
  }, []);

  return (
    <div>
      <MessageWrapper
        isStart={isStart}
        isEnd={isEnd}
        data-test-type="botMessage"
        textDecoration={'underline'}
        cursor={'pointer'}
        onClick={handleUrlClick}
        type="message"
      >
        {urlValue}
      </MessageWrapper>
      <ImageComponent src={siteImage} clickHandler={handleUrlClick} />
    </div>
  );
};

export default withConfig(LinkMessage);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/LinkMessage.js